import { render, staticRenderFns } from "./UserListTable.vue?vue&type=template&id=a1272b3e&scoped=true&"
import script from "./UserListTable.vue?vue&type=script&lang=js&"
export * from "./UserListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1272b3e",
  null
  
)

export default component.exports